// 서비스 파일 구조

import { api } from "@/comn";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";

/*
 * Customs employee service
 * !== 세관 직원 서비스 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/acrdt/newusr`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/acrdt`,
    api_ofcr: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/usr/cstm-ofcrs`,
    co_api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/usr/co`,
    nodes: [
        { path: "/", label: "L_INT_PTL" },
        { path: "/", label: "L_PTL_MGMT" },
    ],
};

/*
 * @ URLS
 * @ 화면에서 사용하는 주소들 정의
 * @ 해당화면의 컴포넌트명 대문자로 정의
 */
export const URLS = {
    ptli0205001s: `${BASE.path}/ptli0205001s`, // Apply for User Registration !== 사용자 등록 신청 ==!
    ptli0205002q: `${BASE.path}/ptli0205002q`, // !== 결재요청팝업 ==!
    ptli0205003q: `${BASE.path}/ptli0205003q`, // !== 결재자 선택 팝업 ==!
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    // Search user registration application information based on login ID !== 로그인ID 기준 사용자 등록 신청 정보 조회==!
    getUsr: (data: any) =>
        api.get(`${BASE.api}/usr-id/${data.usrDmnId}`, { params: comnUtils.toGetParams({ aprvId: data.aprvId }) }),

    // Check user registration application information !== 사용자 등록 신청 정보 조회 ==!
    getUsrRgsrAplyInfo: (data: any) => api.get(`${BASE.api}/new-usr/${data.usrDmnId}/${data.cstmOfcrNo}`),

    // HR system employee number inquiry !== HR시스템 직원번호 조회 ==!
    getHrUsrInfo: (cstmOfcrNo: any) => api.get(`${BASE.api}/hr-usr/${cstmOfcrNo}`),

    // Section search by customs, unit search by section !== 세관별 섹션 조회, 섹션별 유닛 조회 ==!
    getOrgzList: (data: any) => api.get(`${BASE.api}/new-usr/orgz?`, { params: comnUtils.toGetParams(data) }),

    // Get a list of Customs Role. !== 세관 역할 목록을 조회한다. ==!
    getCstmRoleList: (data: any) => api.get(`${BASE.api_ofcr}/roles?`, { params: comnUtils.toGetParams(data) }),

    // Save User Registration Application Information !== 사용자 등록 신청 정보 저장 ==!
    saveUsrRgsrAply: (data: any) => api.post(`${BASE.api}/new-usr`, { ...data }),

    saveUsrAplyId: (data: any) => api.post(`${BASE.api}/usr-aprv-id`, { ...data }),

    // View Approval Path List !== 결재선 목록 조회 (결재요청 팝업용 결재선 목록 조회) ==!
    getAprvPathMgmtList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/aprv?page=${page}&size=${size}`, { params: comnUtils.toGetParams(data) }),

    //  When selecting an Approval Path, View the List of Target Approvers !== 결재선 선택시 대상 결재자 목록 조회 ==!
    getAprvTrgtList: (aprvPrcssPathMgmtId: any, page: number, size: number) => {
        return api.get(`${BASE.api}/aprv/trgt?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams({ aprvPrcssPathMgmtId }),
        });
    },

    // Customs list inquiry !== 세관 목록 조회 ==!
    getCsmtList: () => api.get(`${BASE.api}/aprv/cstmOfce`),

    // View Approval History Information !== 결재 문서 정보 조회 ==!
    getDclaDocInfo: (data: any) => api.get(`${BASE.api}/aprv/dcla/${data}`),

    // View Approval Request Information !== 결재 요청 정보 조회 ==!
    getAprvRqstInfo: (data: any) => api.get(`${BASE.api}/aprv/rqst/${data}`),

    // Save Approval Request Information !== 결재 요청 정보 저장 ==!
    saveAprvRqstInfo: (data: any) => api.post(`${BASE.api}/aprv/rqst`, { ...data }),

    // When Selecting an Customs List, View the List of Target Approvers !== 세관 목록 조회 ==!
    getAprvTreeTrgtUsrList: (data: any, page: number, size: number, aplyUsrDmnId: any) => {
        return api.get(`${BASE.api}/aprv/cstm?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams({ aplyUsrDmnId }),
        });
    },

    // TIN Number Search !== TIN 번호 조회 ==!
    getTinNoLst: (tinNo: any, bizYn: any) => {
        return comnUtils.getCode({
            area: "payerTinNo",
            keyword: tinNo,
            param2: bizYn,
        });
    },

    getBidrDuplCheck: (xtrnUsrIdntfNo: any) =>
        api.get(`${BASE.co_api}/getBidrDuplCheck`, {
            params: comnUtils.toGetParams({ xtrnUsrIdntfNo: xtrnUsrIdntfNo }),
        }),
    // !== 섹션매니저와 결재자 목록을 조회한다. ==!
    getAprvUsrList: (data: any) => {
        return api.get(`${BASE.api}/aprv-usr?`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Get Section manager Y/N !== 섹션매니저 여부 조회 ==!
    getSctnMngrYn: (roleId: any) => api.get(`${BASE.api}/sctn-mngr/${roleId}`),
};

export const SF_USR_RGSR_APLY_INFO: TFormSchema = {
    id: "form_CstmOfcrInfo",
    schema: {
        fileGrpUuid: {
            type: "file",
            label: "L_CSTM_OFCR_PHTO",
            thumbnail: true,
            thumbnailWidth: 100,
            thumbnailHeight: 130,
            bsopClsfCd: "PTL",
            isPublic: true,
        },
        cstmOfcrNo: { type: "text", label: "L_CSTM_OFCR_NO", required: true, maxLength: 10 },
        aprvPrcssStatCdNm: { type: "text", label: "L_PRCS_STTS" },
        usrDmnId: { type: "text", label: "L_USR_ID", required: true },
        usrNm: { type: "text", label: "L_CSTM_OFCR_NAME", required: true },
        usrTelno: { type: "text", label: "L_CSTM_OFCR_TEL_NO" },
        usrTin: { type: "text", label: "L_TIN", maxLength: 9, required: true },
        usrEmlAddr: { type: "text", label: "L_CSTM_OFCR_EML", required: true },
        usrPwd: {
            type: "password",
            label: "L_PWD",
            pattern: {
                value: /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_])[A-Za-z\d\W_]{10,}$/,
                message: "msg.ptl.00761",
            },
            required: true,
        },
        usrPwdCfrm: { type: "password", label: "L_PWD_CFRM", required: true },
        usrPhtoCn: { type: "file", label: "L_CSTM_OFCR_PHTO" },
        cstmSctnOrgzCd: {
            type: "code",
            area: "orgzSub",
            label: "L_CSTM_SCTN",
            popupSize: "md",
            required: true,
        },
        cstmOfceCd: { type: "code", label: "L_CSTM_OFCE", area: "cstmCd" },
        cstmUnitOrgzCd: { type: "select", label: "L_CSTM_UNIT" },
        histSrno: { type: "text" },
        roleId: { type: "select", label: "L_ROLE_NM", required: true },
        intUsrAplyId: { type: "text" },
        actnUsrYn: {
            type: "radio",
            label: "L_ACTN_USR_YN",
            options: [
                { label: "Internal User & Bidder User", value: "Y" },
                { label: "Bidder User", value: "N" },
            ],
            defaultValue: "Y",
        },
    },
};
